import './generic_social_content_view.js.coffee'

class Customer.PrintEmailView extends Monitoring.Views.GenericSocialContentView

  initialize: (@options = {}) ->
    @model = new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(@options.content_json, [])

  render: (avoidDuplications = true) ->
    @renderTextWithHtml()
    window.print()

  renderTextWithHtml: =>
    @$el[0].innerHTML = @model.getValue('text_html') || "<span>#{@model.enhancedContent('text')}</span>"
